import gql from 'graphql-tag';

import { externalShippingAddressDetails } from '../fragments/address';

export const externalShippingAddressCreate = gql`
  mutation externalShippingAddressCreate(
    $input: ExternalShippingAddressCreateInput!
  ) {
    externalShippingAddressCreate(input: $input) {
      external_shipping_address {
        ...externalShippingAddressDetails
      }
    }
  }
  ${externalShippingAddressDetails}
`;

export const externalShippingAddressesCreate = gql`
  mutation externalShippingAddressesCreate(
    $input: ExternalShippingAddressesCreateInput!
  ) {
    externalShippingAddressesCreate(input: $input) {
      success
      external_shipping_addresses {
        ...externalShippingAddressDetails
      }
      invalid_addresses
    }
  }
  ${externalShippingAddressDetails}
`;

export const externalShippingAddressUpdate = gql`
  mutation externalShippingAddressUpdate(
    $input: ExternalShippingAddressUpdateInput!
  ) {
    externalShippingAddressUpdate(input: $input) {
      external_shipping_address {
        ...externalShippingAddressDetails
      }
    }
  }
  ${externalShippingAddressDetails}
`;

export const externalShippingAddressDelete = gql`
  mutation externalShippingAddressDelete(
    $input: ExternalShippingAddressDeleteInput!
  ) {
    externalShippingAddressDelete(input: $input) {
      external_shipping_address {
        id
      }
    }
  }
`;
